var map = {
	"./shapes/backpack.svg": 2757,
	"./shapes/bell.svg": 2758,
	"./shapes/berries.svg": 2759,
	"./shapes/bookmark.svg": 2760,
	"./shapes/brain.svg": 2761,
	"./shapes/brainstorm.svg": 2762,
	"./shapes/campfire.svg": 2763,
	"./shapes/castle.svg": 2764,
	"./shapes/chat.svg": 2765,
	"./shapes/chatDrawn.svg": 2766,
	"./shapes/chatHeads.svg": 2767,
	"./shapes/checkbox.svg": 2768,
	"./shapes/chromosome.svg": 2769,
	"./shapes/cloudSecurity.svg": 2770,
	"./shapes/coffee.svg": 2771,
	"./shapes/cog.svg": 2772,
	"./shapes/community.svg": 2773,
	"./shapes/cultureEagle.svg": 2774,
	"./shapes/cultureMonkey.svg": 2775,
	"./shapes/cultureRabbit.svg": 2776,
	"./shapes/cultureSkull.svg": 2777,
	"./shapes/curve.svg": 2778,
	"./shapes/dataAnalytics.svg": 2779,
	"./shapes/dataEncryption.svg": 2780,
	"./shapes/dataMining.svg": 2781,
	"./shapes/design.svg": 2782,
	"./shapes/dna.svg": 2783,
	"./shapes/donate.svg": 2784,
	"./shapes/drama.svg": 2785,
	"./shapes/earth.svg": 2786,
	"./shapes/familyTree.svg": 2787,
	"./shapes/financialFolder.svg": 2788,
	"./shapes/flask.svg": 2789,
	"./shapes/flowChart.svg": 2790,
	"./shapes/flowChartCircle.svg": 2791,
	"./shapes/flowChartComplex.svg": 2792,
	"./shapes/flowChartScreen.svg": 2793,
	"./shapes/flowChartShapes.svg": 2794,
	"./shapes/flowChartSimple.svg": 2795,
	"./shapes/flower.svg": 2796,
	"./shapes/folderLinked.svg": 2797,
	"./shapes/garage.svg": 2798,
	"./shapes/girl.svg": 2799,
	"./shapes/government.svg": 2800,
	"./shapes/graph.svg": 2801,
	"./shapes/graphVisualization.svg": 2802,
	"./shapes/growingUp.svg": 2803,
	"./shapes/guanine.svg": 2804,
	"./shapes/halfCourt.svg": 2805,
	"./shapes/handLeaf.svg": 2806,
	"./shapes/holePuzzle.svg": 2807,
	"./shapes/idea.svg": 2808,
	"./shapes/ideaShip.svg": 2809,
	"./shapes/imageRecognition.svg": 2810,
	"./shapes/industrialDesign.svg": 2811,
	"./shapes/jacket.svg": 2812,
	"./shapes/laptop.svg": 2813,
	"./shapes/leaf.svg": 2814,
	"./shapes/lightening.svg": 2815,
	"./shapes/love.svg": 2816,
	"./shapes/management.svg": 2817,
	"./shapes/mobileCity.svg": 2818,
	"./shapes/mobileMoney.svg": 2819,
	"./shapes/mobileSend.svg": 2820,
	"./shapes/mountain.svg": 2821,
	"./shapes/movie.svg": 2822,
	"./shapes/networkCentral.svg": 2823,
	"./shapes/networkCloud.svg": 2824,
	"./shapes/networkGraph.svg": 2825,
	"./shapes/openMind.svg": 2826,
	"./shapes/outdoors.svg": 2827,
	"./shapes/personGraph.svg": 2828,
	"./shapes/play.svg": 2829,
	"./shapes/slack.svg": 2830,
	"./shapes/slope.svg": 2831,
	"./shapes/slope2.svg": 2832,
	"./shapes/tree.svg": 2833,
	"./shapes/triangleBottomLeft.svg": 2834,
	"./shapes/triangleTopLeft.svg": 2835,
	"./shapes/waves.svg": 2836,
	"./shapes/womanHead.svg": 2837
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3307;


//////////////////
// WEBPACK FOOTER
// ./src/assets \.\/shapes\/[^\/]+\.(svg)$
// module id = 3307
// module chunks = 0